import { FC } from "react";

import { RelatedCasesTable } from "src/components/case/RelatedCasesTable";
import { PassiveModal } from "src/components/Modal";
import { useGetBlacklistableIdentifiersRelatedCasesQuery } from "src/graphql/anti-fraud/queries/cases/GetCaseBlacklistableIdentifiersRelatedCasesQuery";
import { useT } from "src/internationalization";

export type RelatedCasesModalProps = {
  onClose: () => void;
  caseId: string;
  identifierId: string;
};

// TODO make it wide
export const RelatedCasesModal: FC<RelatedCasesModalProps> = ({
  onClose,
  caseId,
  identifierId,
}) => {
  const t = useT();

  const { data, loading, error } = useGetBlacklistableIdentifiersRelatedCasesQuery({
    variables: {
      id: caseId,
      includeLinkedCaseIdentifiers: true,
    },
  });

  const cases = data[identifierId] ?? [];

  return (
    <PassiveModal
      onClose={onClose}
      size="xl"
      title={t("cases.relatedCases.modal.title", {
        number: loading ? "" : cases.length ?? "",
      })}
      fullHeight
    >
      <div className="h-full">
        <RelatedCasesTable cases={cases} loading={loading} isError={!!error} />
      </div>
    </PassiveModal>
  );
};
